
import TableLayoutGrid from './Grid'
import TableLayoutTable from './Table'

const TableLayout = {
    Grid: TableLayoutGrid,
    Table: TableLayoutTable
}

export default TableLayout

export type TableLayoutType = { Grid: JSX.Element, Table: JSX.Element }